import React from 'react'
import { Button } from '../../../../../components'
import { MenuPannel } from './MenuPannel'

export function RightBox(props) {
  const { selectedTableInfo, orderList } = props
  const allProps = { ...props }

  const styles = {
    wrap: {
      width: "55%",
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    top: {
      flex: 1,
      // backgroundColor: 'yellow',
    },
    btm: {
      // backgroundColor: 'azure',
      padding: 3,
    },
  }
  return (
    <div style={styles.wrap}>
      <div style={styles.top}>
        <MenuPannel {...allProps} />
      </div>
      <div style={styles.btm}>
        <Buttons {...allProps} />
      </div>
    </div>
  )
}

function Buttons(props) {
  const { gStyle, colors, setVisibleOrderSection, setVisiblePaySection } = props
  const styles = {
    wrap: {
      display: 'flex',
      alignItems: 'center',
      margin: 3,
    },
    btn: {
      marginRight: 3,
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    text: { ...gStyle.text },
  }
  return (
    <div style={styles.wrap}>
      <Button
        title="주방 인쇄"
        variant="outline-secondary"
        style={styles.btn}
      />

      <Button
        title="주문서 출력"
        variant="outline-secondary"
        style={styles.btn}
      />

      <Button variant="danger" style={styles.btn}>
        신용<span>카드</span>
      </Button>

      <Button
        title="결제"
        variant="outline-secondary"
        style={styles.btn}
        onClick={() => setVisiblePaySection(true)}
      />

      <Button
        variant="dark"
        style={styles.btn}
        onClick={() => props.setVisibleOrderSection(false)}
      >
        주문<span>완료</span>
      </Button>

      <Button
        title="닫기"
        variant="dark"
        style={styles.btn}
        onClick={() => setVisibleOrderSection(false)}
      />
    </div>
  )
}
